import React, { Component } from 'react'
import { connect } from 'react-redux'

import { selectObject } from '../../../../ducks/editor/objects'
import CanvasObject from '../CanvasObject'

class ComponentPreview extends Component {
  renderObjects() {
    const { component, width, height } = this.props

    if (!component) {
      return null
    }

    const objects = component.children
    const scale = Math.min(width / component.width, height / component.height)
    const offsetX = (width - component.width * scale) / 2
    const offsetY = (height - component.height * scale) / 2
    const zoom = { scale, offset: [offsetX, offsetY] }

    return <ComponentPreviewSub objects={objects} zoom={zoom} />
  }

  render() {
    const { width, height } = this.props

    return (
      <svg width={width} height={height} className="component-preview">
        {this.renderObjects()}
      </svg>
    )
  }
}

export class ComponentPreviewSub extends Component {
  render() {
    const { objects, zoom } = this.props

    return (
      <g className="preview-objects">
        {objects.map(obj => (
          <CanvasObject
            key={obj.id}
            object={obj}
            zoom={zoom}
            hideShadows={false}
          />
        ))}
      </g>
    )
  }
}

const mapStateToProps = (state, { componentId }) => ({
  component: selectObject(state, componentId),
})

export default connect(mapStateToProps)(ComponentPreview)
